<template>
  <span :id="id" :class="$style.warning"> <slot></slot> </span>
</template>

<script>
export default {
  name: "vc-share-info-warning",
  props: {
    id: {
      type: String,
      default: ""
    }
  }
};
</script>

<style module>
.warning {
  font-size: 14px;
  color: gray;
}
.warning ul {
  list-style: none;
  padding-left: 16px;
}

.warning ul > li {
  text-indent: -8px;
}

.warning ul > li:before {
  display: inline-block;
  font-size: inherit;
  font-weight: bold;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  content: "*";
}
</style>
